import { useState } from 'react';
import { revealIntegrationProviderPassword } from '../../../api/integrationAccess.api';
import { reportError } from '../../../helpers/reportError';

/**
 * Admin: the marketplace password we asked the partner to set, fetched on click and held
 * for as long as the section is mounted. Its own route because every reveal is written to
 * the audit log, so it must never fire from a render.
 */
export const useRevealProviderPassword = (locationId: number | string) => {
  const [revealed, setRevealed] = useState<Record<number, string>>({});
  const [pendingId, setPendingId] = useState<number | null>(null);

  const reveal = async (menuProviderId: number) => {
    if (pendingId != null) return;
    setPendingId(menuProviderId);
    try {
      const { data } = await revealIntegrationProviderPassword(
        locationId,
        menuProviderId
      );
      setRevealed((prev) => ({
        ...prev,
        [menuProviderId]: data.data.password,
      }));
    } catch (error) {
      reportError(error);
    } finally {
      setPendingId(null);
    }
  };

  return { revealed, reveal, pendingId };
};
